import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SITE_NAME, SITE_URL, SITEMAP_LASTMOD } from '../../constants/siteSeo';

interface ContactPageStructuredDataProps {
  pageUrl: string;
}

/** /contact 向け JSON-LD（WebPage + BreadcrumbList） */
export default function ContactPageStructuredData({ pageUrl }: ContactPageStructuredDataProps) {
  const { t } = useTranslation();
  const description = t('contact.meta_description');
  const title = t('contact.title');

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: title,
        description,
        dateModified: SITEMAP_LASTMOD,
        isPartOf: { '@id': `${SITE_URL}/#website` },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: SITE_NAME,
            item: SITE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: title,
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
